import { ComponentPropsWithoutRef, ForwardedRef, forwardRef } from "react"
import { STextArea } from "../../acquisitionForm/AcquisitionForm.styled"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { theme } from "../../../../../styles/stitches.config"

function TextAreaRaw(props: ComponentPropsWithoutRef<"textarea">, ref: ForwardedRef<HTMLTextAreaElement>) {
  return (
    <>
      <Spacer size={theme.space.s3_5} />
      <STextArea ref={ref} maxLength={1000} {...props} />
    </>
  )
}

export const FormTextArea = forwardRef(TextAreaRaw)
